<template>
  <div class="register-box mx-auto">
    <div class="register-logo text-center">
      <b>AGS BP Batam</b>
    </div>
    <div class="card shadow">
      <div class="card-body register-card-body">
        <p class="login-box-msg">Register your membership here</p>
        <RegistrationForm @registered="goToLogin"/>
        <p class="mt-3 mb-0 text-center">
          <b-link :to="{name: 'Login'}">
            Already a member? Log In Now!
          </b-link>
        </p>
      </div>
    </div>
    <!-- Credential Modal -->
    <b-modal centered header-bg-variant="success" id="credential" size="sm" title="Keep this password"
             ok-only
             no-close-on-esc
             hide-header-close
             no-close-on-backdrop>
      <h4>Please save this Password</h4>
      <h1 class="text-center">{{ password }}</h1>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="password=null;cancel();$router.replace({ name: 'Login' })">
          OK!
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue';
import RegistrationForm from "@/views/Members/RegistrationForm";
export default {
  name: "Register",
  components: {
    RegistrationForm,
    BLink,
  },
  data: () => ({
    password: null,
  }),
  created() {
    document.body.className = 'register-page';
  },
  methods: {
    goToLogin({user}){
      this.password = user.paswd;
      this.$bvModal.show('credential')
    },
  },
}
</script>

<style scoped>
.register-logo {
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 1px;
}
.register-box {
  max-width: 500px;
  margin: 50px auto 0 auto;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: transparent;
}
@media (max-width: 600px) {
  .register-logo {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
  .register-box {
    margin-top: 25px;
  }
}
</style>
